import { inject, observer } from 'mobx-react';
import PropTypes from 'prop-types';
import React from 'react';
import { Col, Row } from 'reactstrap';

import FormModel from '../../../../models/Form';
import { modelOf } from '../../../../prop-types';
import CheckoutStore from '../../../../store/CheckoutStore';
import FormFieldId from '../../../../types/FormFieldId';
import { labels } from '../../../../util/formLabels';
import SelectField from "../../../form/SelectField";
import CountryStore from "../../../../store/CountryStore";

const createOption = (value, label) => {
  return {
    value,
    label,
  };
};

const CheckoutCountryForm = ({
  checkoutStore,
  countryStore,
  onOrderUpdate,
  countryForm,
}) => {
  const { cancelOrder, shippingInfoIsLoading, order } = checkoutStore;

  const disabled = shippingInfoIsLoading;
  const formName = 'CheckoutCountryForm';
  const fieldName = 'country';

  const handleCountryFieldChange = (e) => {
    cancelOrder();
    const field = order.getShippingCustomerField(FormFieldId.DELIVERY_COUNTRY).field;

    const value = Number(e.target.value);
    field.setValue(value);
    countryStore.setCountryCode(value);

    onOrderUpdate({ withoutTimer: true });
  };

  // Get the country field from the form
  const countryField = countryForm.getFormFields()[0];

  return (
    <div className="CheckoutCountryForm">
      <Row>
        <Col xs={12}>
          <SelectField
            field={countryField}
            formName={formName}
            fieldName={fieldName}
            aria-label={labels.country}
            options={countryStore.countries.map((country) =>
              createOption(String(country.id), country.name)
            )}
            onChange={handleCountryFieldChange}
            disabled={disabled}
          />
        </Col>
      </Row>
    </div>
  );
};

CheckoutCountryForm.propTypes = {
  checkoutStore: modelOf(CheckoutStore).isRequired,
  countryStore: modelOf(CountryStore).isRequired,
  countryForm: modelOf(FormModel).isRequired,
  onOrderUpdate: PropTypes.func.isRequired,
};

export default inject(
  'checkoutStore',
  'countryStore'
)(observer(CheckoutCountryForm));
